import FASTLANE_FEATURE_UUIDS from './constants/fastlaneFeatures';

const main = [
  {
    name: 'Home',
    url: '/home',
    icon: 'menu',
  },
  {
    name: 'Sites and Servers',
    icon: 'menu',
    url: '/sites',
    feature: FASTLANE_FEATURE_UUIDS.DEPLOYMENT,
  },
  {
    name: 'Applications',
    url: '/applications',
    icon: 'menu',
    feature: FASTLANE_FEATURE_UUIDS.PACKAGE,
  },
  {
    name: 'Deployment Wizard',
    icon: 'menu',
    url: '/deployment/wizard',
    feature: FASTLANE_FEATURE_UUIDS.DEPLOYMENT,
  },
  {
    name: 'Deployment History',
    icon: 'menu',
    url: '/deployments',
    feature: FASTLANE_FEATURE_UUIDS.DEPLOYMENT,
  },
  {
    name: 'Usage Guide',
    icon: 'menu',
    url: 'https://harriscomputer.sharepoint.com/:w:/r/sites/Iatric/Product%20Deliverables/iDeploy/Docs/iDeploy_Basic_Usage_Guide.docx?d=w152667c1f1504d87bc2e7142b4a8b8fb&csf=1&web=1&e=b7MMqx',
    newWindow: {
      features: 'noopener,noreferrer',
    },
    feature: FASTLANE_FEATURE_UUIDS.DEPLOYMENT,
  },
];

const data = [];

const advanced = [];

const report = [];

export default {
  main,
  data,
  advanced,
  report,
};
